module.exports = {
  title: '视频号管理',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-sph-manage',
    },
  },
};
